module.exports = __webpack_public_path__ + "img/expert4.5830a8a1.png";